import React, {useEffect} from 'react';
import FilterLayout from "@/Layouts/FilterLayout";
import withStore from "@/hocs/withStore";
import FilterLayoutRadioChildren from "@/Layouts/FilterLayoutRadioChildren";

const ViewDesign = ({...props}) => {
    const {stores = {}} = props;
    const {filterStore = {}} = stores;

    useEffect(() => {
        //
    }, [filterStore.urlDynamic, filterStore.viewDesignControl]);

    if (filterStore.viewDesign.length === 0) return null;

    return (
        <FilterLayout name={`Дизайн`} storeName={`viewDesign`} {...props}>
            <FilterLayoutRadioChildren storeName={`viewDesign`} {...props} />
        </FilterLayout>
    );
}

export default withStore(ViewDesign);
